import {Overlay} from "src/pages/Overlay";

export const FireTVKeyboard = () => {
    return (<Overlay/>);
};

export default FireTVKeyboard;
